import React, { useCallback, useMemo, useState } from 'react'
import noop from 'lodash/noop'
import { ReactFCC } from '@/types/react'

interface PayItForwardCheckoutState {
  isPayItForwardComplete: boolean
  onComplete: () => void
}

const PayItForwardCheckoutContext = React.createContext<PayItForwardCheckoutState>({
  isPayItForwardComplete: false,
  onComplete: noop,
})

export const PayItForwardCheckoutProvider: ReactFCC = ({ children }) => {
  const [isPayItForwardComplete, setPayItForwardComplete] = useState(false)

  const onComplete = useCallback(() => {
    setPayItForwardComplete(true)
  }, [setPayItForwardComplete])

  const value = useMemo(
    () => ({
      isPayItForwardComplete,
      onComplete,
    }),
    [isPayItForwardComplete, onComplete],
  )

  return <PayItForwardCheckoutContext.Provider value={value}>{children}</PayItForwardCheckoutContext.Provider>
}

export const usePayItForwardState = (): PayItForwardCheckoutState => {
  return React.useContext(PayItForwardCheckoutContext)
}
